import styled from 'styled-components'
import { IonContent } from '@ionic/react'

export const StyledIonContent = styled(IonContent)`
  --ion-padding: 0;
`
